import { inject, NgModule } from '@angular/core';

import { IntegrationsMailboxLinkInsertedActionToken } from '../integrations-mailbox-link-inserted-action-token';
import { ManageSchedulerLinkDialogComponentToken } from '../manage-scheduler-link-dialog-injection-token';

@NgModule()
export class RtRedactorInsertsSharedModule {
  constructor() {
    // checks tokens early that so errors will be thrown during bootstrap, not when token is actually used
    inject(ManageSchedulerLinkDialogComponentToken);
    inject(IntegrationsMailboxLinkInsertedActionToken);
  }
}
